function getHeaderOffset () {
  const header = document.querySelector('#header')
  return header ? header.offsetHeight : 80
}

function resolveHash (hash) {
  if (!hash) return ''
  const id = hash.charAt(0) === '#' ? hash.slice(1) : hash
  return id === 'ict' ? 'AboutICT' : id
}

export function scrollToHash (hash, behavior = 'smooth') {
  const id = resolveHash(hash)
  const el = document.getElementById(id)
  if (!el) return false
  const top = el.getBoundingClientRect().top + window.scrollY - getHeaderOffset()
  window.scrollTo({ top: Math.max(0, top), behavior })
  return true
}

function waitForImages (root) {
  const imgs = [...root.querySelectorAll('img')].filter(img => !img.complete)
  if (imgs.length === 0) return Promise.resolve()
  return new Promise((resolve) => {
    let remaining = imgs.length
    const finish = () => {
      remaining -= 1
      if (remaining <= 0) resolve()
    }
    imgs.forEach(img => {
      img.addEventListener('load', finish, { once: true })
      img.addEventListener('error', finish, { once: true })
    })
    setTimeout(resolve, 2000)
  })
}

function nextFrame () {
  return new Promise(resolve => {
    requestAnimationFrame(() => requestAnimationFrame(resolve))
  })
}

export async function scrollToHashWhenReady (hash) {
  if (!hash) return
  await nextFrame()
  const root = document.querySelector('#about') || document.body
  await waitForImages(root)
  await nextFrame()
  if (!scrollToHash(hash, 'smooth')) {
    await new Promise(resolve => setTimeout(resolve, 50))
    scrollToHash(hash, 'smooth')
  }
  setTimeout(() => scrollToHash(hash, 'auto'), 400)
}
